/* src/app/app.component.scss */
.impersonation-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: var(--ion-color-warning, #ffc409);
  color: var(--ion-color-warning-contrast, #000);
  font-size: 13px;
  z-index: 20;
}
.impersonation-banner ion-icon {
  font-size: 18px;
  flex: 0 0 auto;
}
.impersonation-banner .impersonation-banner__text {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.impersonation-banner ion-button {
  flex: 0 0 auto;
  margin: 0;
  --box-shadow: none;
}
:host {
  --yf-android-navigation-bottom-space: 0px;
  --yf-system-bottom-safe-area: max( env(safe-area-inset-bottom), var(--ion-safe-area-bottom, 0px), var(--yf-android-navigation-bottom-space) );
}
:host-context(.plt-android) {
  --yf-android-navigation-bottom-space: clamp(32px, 4vh, 56px);
}
.fab-container-left {
  position: fixed;
  top: var(--yf-spacing0);
  left: var(--yf-spacing1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--yf-spacing1);
  z-index: 1;
  padding: var(--yf-spacing0);
}
@media (max-width: 576px) {
  .fab-container-left {
    margin-top: env(safe-area-inset-top);
  }
}
@media (min-width: 576px) {
  .fab-container-left {
    margin-top: env(safe-area-inset-top);
  }
}
.fab-container-left .funnel-fab {
  margin-left: auto;
}
.fab-container-left ion-fab {
  position: unset;
}
.fab-container-left .left-side {
  display: flex;
  gap: var(--yf-spacing1);
}
@media (max-width: 450px) {
  .fab-container-left .left-side {
    flex-grow: 1;
  }
}
yf-filter-modal {
  position: fixed;
  top: 72px;
  z-index: 2;
}
@media (max-width: 576px) {
  yf-filter-modal {
    margin-top: env(safe-area-inset-top);
    right: var(--yf-spacing2);
    left: var(--yf-spacing2);
  }
}
@media (min-width: 576px) {
  yf-filter-modal {
    margin-top: env(safe-area-inset-top);
    right: var(--yf-spacing1);
  }
}
.fab-button-disabled {
  opacity: 0.8;
}
.button-disabled {
  opacity: 0.8;
}
ion-buttons {
  padding-left: var(--yf-spacing1);
  padding-right: var(--yf-spacing1);
  justify-content: space-around;
}
ion-button {
  margin-left: 4px;
  margin-right: 4px;
}
ion-content {
  margin-bottom: var(--yf-system-bottom-safe-area);
}
ion-menu-toggle ion-icon {
  font-size: 30px;
  vertical-align: middle;
}
ion-footer ion-toolbar {
  border-radius: var(--yf-spacing1) var(--yf-spacing1) 0 0;
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  height: calc(52px + var(--yf-system-bottom-safe-area));
  padding-bottom: var(--yf-system-bottom-safe-area);
}
.footer-button-container {
  flex-grow: 2;
  display: flex;
  justify-content: space-around;
  left: var(--yf-spacing2);
  padding: 0 var(--yf-spacing2);
}
.app-navbar-notch {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  height: env(safe-area-inset-top);
  --webkit-backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}
.fab-container-right {
  position: fixed;
  top: var(--yf-spacing0);
  right: var(--yf-spacing1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--yf-spacing1);
  z-index: 1;
  padding: var(--yf-spacing0);
}
@media (max-width: 576px) {
  .fab-container-right {
    margin-top: env(safe-area-inset-top);
  }
}
@media (min-width: 576px) {
  .fab-container-right {
    margin-top: env(safe-area-inset-top);
  }
}
.fab-container-right .funnel-fab {
  margin-left: auto;
}
.fab-container-right ion-fab {
  position: unset;
}
::ng-deep ion-toast.toast-filter-error {
  --background: var(--ion-color-warning);
  --box-shadow: 3px 3px 10px 0 rgba(0, 0, 0, 0.2);
  --color: #4b4a50;
}
::ng-deep ion-toast.toast-filter-error::part(message) {
  font-style: italic;
}
::ng-deep ion-toast.toast-filter-error::part(button) {
  border-left: 1px solid #d2d2d2;
  color: #030207;
  font-size: 15px;
}
ion-button {
  position: relative;
}
ion-button .notification-badge {
  position: absolute;
  top: 1px;
  right: -5px;
  min-width: 8px;
  height: 14px;
  border-radius: 80%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fab-container-bottom-left {
  position: fixed;
  bottom: calc(52px + env(safe-area-inset-bottom));
  left: var(--yf-spacing1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--yf-spacing1);
  z-index: 1;
  padding: var(--yf-spacing0);
}
.fab-container-bottom-left .funnel-fab {
  margin-left: auto;
}
.fab-container-bottom-left ion-fab {
  position: unset;
}
.fab-container-bottom-left .left-side {
  display: flex;
  gap: var(--yf-spacing1);
}
@media (max-width: 450px) {
  .fab-container-bottom-left .left-side {
    flex-grow: 1;
  }
}
.fab-container-bottom-left ion-icon {
  position: absolute;
}
@media (max-width: 576px) {
  .fab-container-bottom-left {
    margin-top: env(safe-area-inset-top);
  }
}
@media (min-width: 576px) {
  .fab-container-bottom-left {
    margin-top: env(safe-area-inset-top);
  }
}
.fab-container-bottom-left ion-icon:nth-of-type(2) {
  font-size: var(--yf-spacing2);
}
ion-fab-button {
  height: 48px;
  width: 48px;
}
/*# sourceMappingURL=app.component.css.map */
